'use client';

import { ReactNode, useState } from 'react';
import { Resort } from '@/utils/platform-api/__generated__/graphql';
import clsx from 'clsx';

import Button from '../ui/button';

/*
disclaimer_pre: String <-- ALL ABOUT #1 w/disclaimer box/styling
  desc_primary: String <-- ALL ABOUT #2
  desc_facility: String <-- ALL ABOUT #3 h3 = "Facilities"
  desc_transport: String <-- ALL ABOUT #4 h3 = "Transportation" or "Getting There"?
  desc_location: String <-- ALL ABOUT #5 h3 = "Location"
  disclaimer_post_one: String <-- ALL ABOUT #6  w/disclaimer box/styling
  disclaimer_post_two: String <-- ALL ABOUT #7  w/disclaimer box/styling
*/

const ResortAllAbout: React.FC<{ resort: Resort; children: ReactNode }> = ({
  resort,
  children,
}) => {
  const [showMore, setShowMore] = useState(false);
  return (
    <div className="flex flex-col gap-4 py-4">
      <div className="flex flex-col gap-[1rem]">
        <h3 className="text-center">
          All About {resort.marketing?.common_name || resort.name}
        </h3>
        <section
          className={clsx(
            'relative mx-auto flex max-w-screen-md flex-col gap-4 text-justify',
            !showMore && '!line-clamp-[10]'
          )}
        >
          {children}
          {!showMore && (
            <div className="absolute bottom-0 h-16 w-full bg-gradient-to-b from-transparent to-white" />
          )}
        </section>
        <div className="flex w-full items-center justify-center">
          <Button
            className="flex flex-col items-center justify-center text-center text-gray-7"
            style="text"
            onClick={() => setShowMore((prev) => !prev)}
          >
            <span className="text-inherit">
              {showMore ? 'Show Less' : 'Show More'}
            </span>
            <div className="flex items-center justify-center">
              <svg
                className={clsx(showMore ? '-rotate-90' : 'rotate-90')}
                width="12"
                height="20"
                viewBox="0 0 14 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M13.2103 13.2103C13.8798 12.5409 13.8798 11.4538 13.2103 10.7843L2.92807 0.502063C2.25865 -0.167356 1.17151 -0.167356 0.502095 0.502063C-0.167323 1.17148 -0.167323 2.25862 0.502095 2.92804L9.57406 12L0.507448 21.072C-0.16197 21.7414 -0.16197 22.8285 0.507448 23.4979C1.17687 24.1674 2.264 24.1674 2.93342 23.4979L13.2157 13.2157L13.2103 13.2103Z"
                />
              </svg>
            </div>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResortAllAbout;
